const ValuesGrid = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Compliance First',
      description: 'Every project adheres strictly to Australian Standards AS/NZS 3000 and regulatory requirements. We maintain comprehensive documentation and certification to ensure your electrical systems meet all legal and insurance obligations.',
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Excellence',
      description: 'Our focus is exclusively on commercial electrical work. This specialisation ensures our team understands the unique demands of business environments, delivering solutions that minimise downtime and maximise reliability.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Reliable Service',
      description: 'We respond promptly to enquiries, complete projects on schedule, and provide ongoing support through preventative maintenance programs. Our clients depend on us for consistent, professional service delivery.',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-navy mb-16 text-center">Our Core Values</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white p-10 rounded-lg hover:shadow-xl transition-all group border-b-4 border-transparent hover:border-gold"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${value.icon} text-gold text-7xl`}></i>
              </div>
              <h3 className="text-navy font-bold text-xl mb-4">{value.title}</h3>
              <p className="text-charcoal text-sm leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesGrid;